export class Internet {

  id: number;
  type: string;
  technology: string;
  bandwidth: string;
  technologyMonthly: number;
  technologyUnique: number;
  ipAddress: string;
  ipAddressMonthly: number;
  ipAddressUnique: number;
  slaLevel: string;
  slaLevelMonthly: number;
  slaLevelUnique: number;
  supportTime: string;
  supportTimeMonthly: number;
  supportTimeUnique: number;
  router: string;
  routerMonthly: number;
  routerUnique: number;
  totalMonthlyCost: number;
  totalUniqueCost: number;

  endToendMonthlyCost: number;
  endToendUniqueCost: number;
  checkendtoend: boolean;

  dslMonthlyCost: number;
  dslUniqueCost: number;
  checkDsl: boolean;

  simMonthlyCost: number;
  simUniqueCost: number;
  checkSim: boolean;


  adressInput: string;
  constructor() {
    this.type = null;
    this.technology = 'DSL/ g.Fast';
    this.bandwidth = '50/50';
    this.technologyMonthly = 0;
    this.technologyUnique = 0;

    this.ipAddress = 'DHCP';
    this.ipAddressMonthly = 0;
    this.ipAddressUnique = 0;

    this.router = 'No router';
    this.routerMonthly = 0;
    this.routerUnique = 0;

    this.checkendtoend = false;
    this.endToendMonthlyCost = 0;
    this.endToendUniqueCost = 0;

    this.dslMonthlyCost = 0;
    this.dslUniqueCost = 0;
    this.checkDsl = false;

    this.simMonthlyCost = 0;
    this.simUniqueCost = 0;
    this.checkSim = false;

    this.slaLevel = 'Unmanaged';
    this.slaLevelMonthly = 0;
    this.slaLevelUnique = 0;

    this.supportTime = '5/10';
    this.supportTimeMonthly = 0;
    this.supportTimeUnique = 0;

    this.totalMonthlyCost = 0;
    this.totalUniqueCost = 0;
    this.adressInput = '';

  }
}



// WEBPACK FOOTER //
// ./src/models/internet.ts